import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



window.captchaLoadCallback = function (){
        window.VueApp.$store.commit("captchaDependenciesLoaded");
      };

window.VueApp = createApp(App).use(store).use(router).mount('#app')
